import { Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { AndFilter, ComparisonFilter, enmConditionalOperators, IFilter, InFilter } from "../../components/infrastructure/filtering";
import { Province } from "../province";
import { ICity, ICityProps, ICityStates } from "./interfaces";


export class City extends EntityManager<ICity, ICityProps, ICityStates> {
    static initMetadata = (): IMetadata => {
        return {
            name: "City",
            excludeNavigationFromSearch: true,
            title: "شهر",
            Properties: [
                {
                    title: "استان",
                    dataIndex: "ParentId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 300,
                    rules: [{ required: true, message: 'لطفا استان را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Province,
                        lookupProperty: "Province",
                        lookupDisplayFields: ["Name"]
                    },
                    showInLookup: false
                },
                {
                    title: "نام شهر",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام شهر را وارد نمایید' }]
                },
                {
                    title: "نام لاتین",
                    dataIndex: "NameEn",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showInLookup: false
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }],
                    showInLookup: false
                }
            ]
        };
    }

    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;
        this.originalFilter = () => {
            const params = this.props.params && this.props.params();
            const filters: IFilter[] = [];
            if (!!params) {
                if (params.province)
                    filters.push(new ComparisonFilter("ParentId", enmConditionalOperators.Equal, params.province.Id));
                if (params.codes?.length)
                    filters.push(new InFilter("Code", params.codes));
                if (filters.length)
                    return new AndFilter(filters);
            }
        };
        this.onEntityAdded = (entity) => {
            let province = this.props.params && this.props.params().province;
            if (province) {
                entity.ParentId = province!.Id;
                entity.Province = province!;
                entity.ModifiedProperties.push("ParentId");
            }
            return true;
        };
        this.extraHeaderNodes = () => {
            return (
                <Descriptions className="header-page">
                    <Descriptions.Item label="نام استان">{this.props.params && this.props.params().province?.Name}</Descriptions.Item>
                </Descriptions>
            );
        };
    }
}